/*
 * CMP-008 Text input / textarea / search — Phase A1 (Figma 17:9246–17:9251, a11y rules 40:9057).
 * Validation runs on blur and on form submit, never per keystroke (UI Kit §9). The counter is a visual
 * aid and updates while typing. On a failed submit the first invalid control receives focus and its
 * inline error is announced (aria-live) and linked with aria-describedby.
 * Host API on the element: validate() -> boolean, setError(msg), clearError(), setSuccess(msg),
 * setValidating(bool). No dependencies. validateValue is exported for node:test.
 */
(function (root) {
  /** rules: { required, minLength, maxLength, pattern (string) } -> { valid, code } */
  function validateValue(value, rules) {
    var v = value == null ? '' : String(value);
    var r = rules || {};
    if (r.required && v.trim().length === 0) return { valid: false, code: 'required' };
    if (v.length > 0 && r.minLength && v.length < r.minLength) return { valid: false, code: 'minLength' };
    if (r.maxLength && v.length > r.maxLength) return { valid: false, code: 'maxLength' };
    if (v.length > 0 && r.pattern && !new RegExp('^(?:' + r.pattern + ')$').test(v)) return { valid: false, code: 'pattern' };
    return { valid: true, code: null };
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { validateValue: validateValue };
  if (typeof customElements === 'undefined' || customElements.get('nc-input')) return;

  var DEFAULT_MESSAGES = {
    required: 'Este campo es obligatorio',
    minLength: 'Es demasiado corto',
    maxLength: 'Es demasiado largo',
    pattern: 'El formato no es válido'
  };

  class NcInput extends HTMLElement {
    connectedCallback() {
      this.control = this.querySelector('.nc-input__control');
      this.message = this.querySelector('.nc-input__message');
      this.counter = this.querySelector('.nc-input__counter');
      if (!this.control) return;
      var serverError = this.getAttribute('data-state') === 'error';
      this.helperText = this.dataset.helper !== undefined ? this.dataset.helper : (serverError || !this.message ? '' : this.message.textContent.trim());
      // A server-rendered error stays until the user changes the value (blur alone must not erase it).
      this.serverErrorValue = serverError ? this.control.value : null;
      this.control.addEventListener('blur', this.validate.bind(this));
      this.control.addEventListener('input', this.updateCounter.bind(this));
      this.form = this.control.form;
      if (this.form && !this.form.__ncInputBound) {
        this.form.__ncInputBound = true;
        // Capture phase + stopImmediatePropagation: when something is invalid, no other submit listener
        // (e.g. the host's own handler registered earlier) sees the event.
        this.form.addEventListener('submit', function (e) {
          var inputs = Array.prototype.slice.call(this.querySelectorAll('nc-input'));
          var firstInvalid = null;
          inputs.forEach(function (el) { if (!el.validate() && !firstInvalid) firstInvalid = el; });
          if (firstInvalid) {
            e.preventDefault();
            e.stopImmediatePropagation();
            firstInvalid.control.focus();
          }
        }, true);
      }
      this.updateCounter();
    }

    rules() {
      var c = this.control;
      var d = this.dataset;
      var max = parseInt(d.maxLength || c.getAttribute('maxlength') || '0', 10) || 0;
      return {
        required: c.required || d.required === 'true',
        minLength: parseInt(d.minLength || '0', 10) || 0,
        maxLength: max,
        pattern: d.pattern || ''
      };
    }

    updateCounter() {
      if (!this.counter) return;
      var max = this.rules().maxLength;
      if (max) this.counter.textContent = this.control.value.length + '/' + max;
    }

    validate() {
      if (this.control.disabled || this.control.readOnly) return true;
      if (this.serverErrorValue !== null) {
        if (this.control.value === this.serverErrorValue) return false;
        this.serverErrorValue = null;
      }
      var res = validateValue(this.control.value, this.rules());
      if (res.valid) { this.clearError(); return true; }
      var msg = this.dataset['msg' + res.code.charAt(0).toUpperCase() + res.code.slice(1)] || DEFAULT_MESSAGES[res.code];
      this.setError(msg);
      return false;
    }

    setError(msg) { this.setState('error', msg); }
    setSuccess(msg) { this.setState('success', msg); }
    clearError() { this.setState('', this.helperText); }
    setValidating(on) { this.setState(on ? 'validating' : '', this.helperText); }

    setState(state, text) {
      if (state) this.setAttribute('data-state', state); else this.removeAttribute('data-state');
      if (state === 'error') this.control.setAttribute('aria-invalid', 'true'); else this.control.removeAttribute('aria-invalid');
      this.control.setAttribute('aria-busy', state === 'validating' ? 'true' : 'false');
      if (this.message) {
        this.message.textContent = text || '';
        this.message.hidden = !text;
        // a message set at runtime is linked even when the field rendered without one (e.g. the tag limit, SCR-011)
        if (text && this.message.id) {
          var ids = (this.control.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
          if (ids.indexOf(this.message.id) < 0) { ids.push(this.message.id); this.control.setAttribute('aria-describedby', ids.join(' ')); }
        }
      }
    }
  }

  customElements.define('nc-input', NcInput);
})(typeof window !== 'undefined' ? window : globalThis);
